<template>
  <div class="root">
    <section class="section">
      <div class="container narrow-container">
        <div
          class="has-diffused-shadow has-background-white has-large-padding has-border-radius-16"
        >
          <h2
            class="is-size-4-5 has-text-grey-dark has-text-weight-bold"
          >Improve Transcript Accuracy</h2>
          <div class="divider"></div>
          <el-tabs class="has-large-margin-top">
            <el-tab-pane label="Add Custom Vocabulary">
              <p class="is-size-6-7 has-text-grey-dark mb-4">
                Custom vocabulary is used to improve the quality of transcriptions. Please add your
                domain specific phrases and terms (up to 50k of text). After saving your vocabulary
                it takes a minute to be processed
              </p>
              <el-input
                type="textarea"
                :rows="8"
                placeholder="One entry per line"
                v-model="vocabText"
              ></el-input>
              <div class="mx-auto" style="width: 200px;">
                <el-button class="mt-5" disabled style="width:200px;">COMING SOON</el-button>
              </div>
            </el-tab-pane>
            <el-tab-pane label="Add Text Substitutions">
              <p class="is-size-6-7 has-text-grey-dark mb-4">
                Substitutions are made to captions as they are processed. Add or edit tweaks below
                to fix common transcription or case issues. The required format is one peroperty per
                line, for example: R.S.S.=RSS.
              </p>
              <p class="is-size-6-7 has-text-grey-dark mb-4">
                The case of the left hand expression is ignored, but the case of the right
                hand expression is preserved.
              </p>
              <el-input
                type="textarea"
                :rows="8"
                placeholder="One entry per line"
                v-model="tweakText"
              ></el-input>
              <div class="mx-auto" style="width: 200px;">
                <el-button class="mt-5" disabled style="width:200px;">COMING SOON</el-button>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      vocabText: '',
      tweakText: '',
    };
  },
};
</script>

<style lang="scss" scoped>
.root {
  min-height: 100vh;
  background-image: linear-gradient(180deg, #fff, #fff 400px, #dde6f86e 401px);
}
</style>
